import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Loader from '../../components/Loader'
import { getById } from '../../lib/RestApi/customApiHandler'
import AddTravelRequest from './AddTravelRequest'
export default function EditTravelRequest() {
  const params = useParams()
  const [allowanceRequest, setAllowanceRequest] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getById('/allowance/requests', params.allowanceRequest).then((res) => {
      setAllowanceRequest(res.data)
      setLoading(false)
    })
  }, [params.allowanceRequest])

  return <> {loading ? <Loader /> : <AddTravelRequest allowanceRequest={allowanceRequest} />} </>
}
